// calculateGrandTotal — spec §8.7.
// Grand = round( subtotal + tax - (custom+coupon) - storeCredit - lottery/scratcher - giftCard - loyalty ).
// NCA (surcharge) and tip are intentionally EXCLUDED here — they are added at payment time.

import { roundHalfUp, toNum } from "./money";

export function calculateGrandTotal({
  subtotal,
  tax,
  couponPlusCustom = 0,
  storeCredit = 0,
  lotteryScratcher = 0,
  giftCard = 0,
  loyalty = 0,
}) {
  let total = toNum(subtotal) + toNum(tax);
  if (toNum(couponPlusCustom) > 0) total -= toNum(couponPlusCustom);
  total -= toNum(storeCredit);
  total -= toNum(lotteryScratcher);
  total -= toNum(giftCard);
  total -= toNum(loyalty);
  if (isNaN(total)) total = 0;
  // ⚠️ MONEY FIX: the reductions (coupon / store credit / gift card / loyalty) are TENDERS capped at
  // the balance — they can never make a customer OWE a negative amount. Only a lottery/scratcher
  // PAYOUT legitimately drives the total below zero (the register then pays the customer in cash), so
  // floor at 0 unless a payout is present. Without this, loyalty covering the full balance saved the
  // order total as negative (e.g. −$0.11 on a $0.99 sale).
  if (toNum(lotteryScratcher) <= 0) total = Math.max(total, 0);
  return roundHalfUp(total);
}
